import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { VehicleTab } from "./types";

/**
 * Tabovi vozila, redom kako stoje na ekranu. Popis je jedini izvor istine — dodavanje taba znači
 * jedan redak ovdje, a ne novi blok u razmatku.
 */
export const VEHICLE_TABS: VehicleTab[] = [
  {
    route: FleetVehicleRoutes.FleetVehicleDetailPageRouter,
    icon: "/media/icons/info.svg",
    label: "admin.fleet.vehicles.tab.details",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleDocumentSearchPageRouter,
    icon: "/media/icons/document.svg",
    label: "admin.fleet.vehicles.tab.documents",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleExpenseSearchPageRouter,
    icon: "/media/icons/expense.svg",
    label: "admin.fleet.vehicles.tab.expense",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleOfferSearchPageRouter,
    icon: "/media/icons/offer.svg",
    label: "admin.fleet.vehicles.tab.offer",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleContractSearchPageRouter,
    icon: "/media/icons/contract.svg",
    label: "admin.fleet.vehicles.tab.contracts",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleInvoiceSearchPageRouter,
    icon: "/media/icons/invoice.svg",
    label: "admin.fleet.vehicles.tab.invoices",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleFireExtinguisherSearchPageRouter,
    icon: "/media/icons/fire-extinguisher.svg",
    label: "admin.fleet.vehicles.tab.fireextinguisher",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleTireSetSearchPageRouter,
    icon: "/media/icons/tire.svg",
    label: "admin.fleet.vehicles.tab.tires",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleDamageSearchPageRouter,
    icon: "/media/icons/damage.svg",
    label: "admin.fleet.vehicles.tab.damages",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleServiceSearchPageRouter,
    icon: "/media/icons/service.svg",
    label: "admin.fleet.vehicles.tab.services",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleDriverSearchPageRouter,
    icon: "/media/icons/users.svg",
    label: "admin.fleet.vehicles.tab.drivers",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleTransferSearchPageRouter,
    icon: "/media/icons/location.svg",
    label: "admin.fleet.vehicles.tab.transfers",
  },
  {
    route: FleetVehicleRoutes.FleetVehicleHistorySearchPageRouter,
    icon: "/media/icons/history.svg",
    label: "admin.fleet.vehicles.tab.history",
  },
];
